import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=9464284a"
import script from "./Languages.vue?vue&type=script&lang=ts"
export * from "./Languages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9464284a')) {
      api.createRecord('9464284a', component.options)
    } else {
      api.reload('9464284a', component.options)
    }
    module.hot.accept("./Languages.vue?vue&type=template&id=9464284a", function () {
      api.rerender('9464284a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Languages.vue"
export default component.exports